import { render, staticRenderFns } from "./chemMsdsManage.vue?vue&type=template&id=792489cc"
import script from "./chemMsdsManage.vue?vue&type=script&lang=js"
export * from "./chemMsdsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792489cc')) {
      api.createRecord('792489cc', component.options)
    } else {
      api.reload('792489cc', component.options)
    }
    module.hot.accept("./chemMsdsManage.vue?vue&type=template&id=792489cc", function () {
      api.rerender('792489cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemMsdsManage.vue"
export default component.exports